export default "__VITE_ASSET__$ZyRK9D5__"